import React, { useEffect } from 'react';
import { NextPage } from 'next';

import LayoutCustom from '../../components/LayoutCustom';
import { Benefits } from '../../components/Benefits';
import { trackEvent } from '@/utils/dataLayer/baseDataLayer';
import { benefitsPageEvents } from '@/utils/dataLayer/benefitsPage';

const BenefitsNewPage: NextPage = () => {
  const eventParams = {
    ...benefitsPageEvents.hiringFloatClick,
  };

  useEffect(() => {
    trackEvent({
      eventParams: {
        ...benefitsPageEvents.home,
      },
    });
  }, []);

  return (
    <LayoutCustom eventParams={eventParams}>
      <Benefits />
    </LayoutCustom>
  );
};

export default BenefitsNewPage;
